import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FuelTextArea } from '@frete.com/fuel-react';
import { maxLength } from './schema';
import { FormPropsInterface, SchemaType } from './FormTypes';
import * as Styled from './FormStyles';

function Form({ onSubmit }: FormPropsInterface) {
  const nameField = 'reason';
  const { control, getFieldState, register } = useFormContext();
  const { handleSubmit } = useFormContext<SchemaType>();
  const errorField = getFieldState(nameField).error?.message;

  return (
    <Styled.Wrapper>
      <form
        data-testid="unrecognized-form"
        onSubmit={handleSubmit((data) => onSubmit(data))}
      >
        <Controller
          name={nameField}
          control={control}
          render={({ field: { value, onBlur, onChange } }) => (
            <FuelTextArea
              displayCounter
              name={nameField}
              placeholder="Escreva as observações aqui..."
              data-testid={`input-${nameField}`}
              label="Observações (opcional)"
              onInput={onChange}
              onBlur={onBlur}
              ref={register(nameField).ref}
              state={errorField ? 'error' : undefined}
              hint={errorField}
              value={value}
              maxlength={maxLength}
              rows={3}
            />
          )}
          defaultValue=""
        />
      </form>
    </Styled.Wrapper>
  );
}

export default Form;
